import { render, staticRenderFns } from "./specials-slider-6040.vue?vue&type=template&id=681b764e&scoped=true&"
import script from "./specials-slider-6040.vue?vue&type=script&lang=js&"
export * from "./specials-slider-6040.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=681b764e&scoped=true&lang=css&"
import style1 from "./specials-slider-6040.vue?vue&type=style&index=1&id=681b764e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b764e",
  null
  
)

export default component.exports